/* eslint-disable */
import { CommonGet} from '../../../helpers/HttpClient';

export default{
    GetAllGroups,
    GetPriceApprovalReportDetails
};

async function GetAllGroups() {
    const response = await CommonGet('/api/Group/GetAllGroups', null);
    return response.data;
}

async function GetPriceApprovalReportDetails(groupID,date) {
    const response = await CommonGet('/api/PriceApprovalReport/GetPriceApprovalReportDetails','groupID=' + groupID + '&date='+ date);
    return response.data;
}

